import { z } from 'zod';

import type { VoidScaleTicketRequest, VoidScaleTicketResponse } from './void-scale-ticket.dto.js';
import {
  ShipmentScaleTicketSchema,
} from './shipments-shared.schema.js';

export const VoidScaleTicketRequestSchema: z.ZodType<VoidScaleTicketRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
    scaleTicketId: z.uuid(),
    reason: z.string().trim().min(1),
  })
  .strict();

export const VoidScaleTicketResponseSchema: z.ZodType<VoidScaleTicketResponse> = z
  .object({
    scaleTicket: ShipmentScaleTicketSchema,
  })
  .strict();
